import ExclusiveDealsPush from '@ui/ExclusiveDeals/Push/component'

export default (): void => {
  const exclusiveDealsPushEl = document.querySelector<HTMLElement>('.exclusive-deals-push')
  exclusiveDealsPushEl && ExclusiveDealsPush(exclusiveDealsPushEl)
}
